export interface UnpinAppResponse {
  success: boolean
  data: unknown
}
